import constate from 'constate';
import { useCallback, useState } from 'react';

import { BomPartViewByType } from 'bom/enums';

const useViewBy = () => {
  const [viewBy, setViewBy] = useState<BomPartViewByType>(BomPartViewByType.PART);

  const changeViewBy = useCallback(
    async (newViewBy: BomPartViewByType) => {
      if (newViewBy === viewBy) {
        return;
      }

      setViewBy(newViewBy);
    },
    [viewBy]
  );

  return { viewBy, changeViewBy, setViewBy };
};

export const [ViewByProvider, useViewByContext] = constate(useViewBy);
